import { render, staticRenderFns } from "./nutritionistForm.vue?vue&type=template&id=dc0c6b58&"
import script from "./nutritionistForm.vue?vue&type=script&lang=js&"
export * from "./nutritionistForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports